import { VariableIsolineSignalBuffer } from "../core/objects/webgl/signal/variable-isoline-signal-buffer";
import { RingBuffer } from "../../web-graphics";

export class VariableUniversalSignalBuffer extends VariableIsolineSignalBuffer {
  // ppmm: pixels per mm, plotSize: { width: 0, height: 0}, windowSize: { width: 0, height: 0 }
  constructor(settings) {
    super(settings);
  }

  init() {
    if (!this.settings.isDataSync) {
      this.sourceDataBuffer = new RingBuffer(this.dataBuffer.length);
      this.sourceDataBuffer.buffer.fill(0);
    }
    super.init();
  }

  createBuffers() {
    super.createBuffers();
    if (
      this.settings.isDataSync &&
      (this.sourceDataBuffer === undefined || this.sourceDataBuffer.length < this.dataBuffer.length)
    ) {
      let currData = [];
      if (this.sourceDataBuffer !== undefined && this.sourceDataBuffer.actualLength > 0) {
        currData.length = this.sourceDataBuffer.actualLength;
        let bufferIndex = 0;
        this.sourceDataBuffer.getLastData(this.sourceDataBuffer.actualLength, data => {
          currData[bufferIndex] = data;
          ++bufferIndex;
          return true;
        });
      }
      this.sourceDataBuffer = new RingBuffer(this.dataBuffer.length);
      if (currData.length > 0) {
        this.sourceDataBuffer.addDataArray(currData, "right");
      }
    }
  }

  loadDataFromSource() {
    if (this.sourceDataBuffer.length == 0) {
      return;
    }
    if (this.dataBuffer.length == 0) {
      this.dataBuffer.length = this.sourceDataBuffer.length;
    }
    this.sourceDataBuffer.getLastData(this.dataBuffer.length, data => {
      this._putData(data, false);
      return true;
    });
    /*
    if (this.onIsolineChangeAction !== undefined) {
      this.onIsolineChangeAction();
    }
    */
  }

  resetSourceBuffer() {
    if (this.settings.isDataSync) {
      this.sourceDataBuffer = new RingBuffer(this.dataBuffer.length);
    }
    this.sourceDataBuffer.buffer.fill(0);
    this.sourceDataBuffer.reset();
  }

  // add data without valid flag check
  // data in user units
  putData(data) {
    super.putData(data);
    this.sourceDataBuffer.addData(data, "right");
  }
}
